// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style.scss
// module id = 197
// module chunks = 0